exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils"), "");
// Module
exports.push([module.id, ".action-list-add-row-5c5zF3t4mwr{background-color:var(--action-list);border-radius:2px;cursor:pointer;margin:2px 0;position:relative}@media screen and (-ms-high-contrast: active){.action-list-add-row-5c5zF3t4mwr:focus{outline:2px dotted buttonText;outline-offset:1px}}.action-list-add-row-5c5zF3t4mwr:hover{background-color:var(--action-list-hover)}@media screen and (-ms-high-contrast: active){.action-list-add-row-5c5zF3t4mwr:hover{border:1px solid highlight}.action-list-add-row-5c5zF3t4mwr:hover .action-list-add-text-76ezpGXBmwr{color:highlight}.action-list-add-row-5c5zF3t4mwr:hover .action-list-add-icon-1K0djn6Tmwr path{fill:highlight}}@media screen and (-ms-high-contrast: active){.action-list-add-row-5c5zF3t4mwr{border:1px solid buttonText}}.action-list-add-container-2LPIfHenmwr{display:flex;align-items:center;padding-left:3px}.action-list-add-container-2LPIfHenmwr .action-list-add-text-76ezpGXBmwr{padding-left:13px}.action-list-add-large-container-6yVyVrdLmwr{padding:8px 0 8px 4px}.action-list-add-large-container-6yVyVrdLmwr .action-list-add-text-76ezpGXBmwr{padding-left:16px}.action-list-add-text-76ezpGXBmwr{margin:0;color:var(--link-text)}@media screen and (-ms-high-contrast: active){.action-list-add-text-76ezpGXBmwr{color:buttonText}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"row": "action-list-add-row-5c5zF3t4mwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils").locals["focus"] + "",
	"text": "action-list-add-text-76ezpGXBmwr",
	"icon": "action-list-add-icon-1K0djn6Tmwr",
	"container": "action-list-add-container-2LPIfHenmwr",
	"large-container": "action-list-add-large-container-6yVyVrdLmwr action-list-add-container-2LPIfHenmwr",
	"largeContainer": "action-list-add-large-container-6yVyVrdLmwr action-list-add-container-2LPIfHenmwr"
};